<!--
  ~ Copyright (C) 2026 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<main
  class="v3-main"
  [style.background-image]="backgroundImageStyle"
  [style.background-color]="backgroundColorStyle"
  [class.dynamic-background-color]="organizationData?.landingPage?.useBackgroundColourFill"
  [class.split-screen]="isSplitScreen"
>
  @if (showMaintenanceOverlay) {
    <div class="maintenance-layer">
      <div class="maintenance-layer-inner" [innerHTML]="'translations.maintenance.overlayText' | transloco"></div>
    </div>
  }

  <div class="v3-form-container" [class.split-screen]="isSplitScreen">
    <div class="v3-login-card" [class.split-screen]="isSplitScreen">
      <div class="v3-brand-row">
        <!-- organizationData.landingPage.landingLogo (v2) is a wide banner mark; this 1:1 brand slot needs the square org logo instead -->
        <img class="v3-brand-logo" width="44" height="44" [src]="organizationData?.logo" alt="{{ organizationData?.name }} Logo" />
        <span class="v3-brand-name semibold">{{ organizationData?.name }}</span>
      </div>

      <ng-content></ng-content>
    </div>
  </div>
</main>
